var Expand = {};

Expand.order = [
  [0, 1, 2, 3, 4, 6, 7, 5, 8, 9], // adjective
  [0, 1, 2, 3, 4, 6, 7, 5, 8, 9], // noun
  [0, 1, 2, 3, 4, 6, 7, 5, 8, 9], // pronoun
  [0, 4, 6, 7, 5, 2, 3, 1, 8, 9], // verb: pers(4), case(6), gend(7), num(5), tense(2), voice(3), mood(1), N/A(8), +que(9)
  [0, 4, 3, 1, 2, 6, 7, 5, 8, 9], // participle
];

Expand.xa = {
  'ai-------': 'indeclinable adj',
  'c--------': 'conjunction',
  'd--------': 'adverb',
  'd-------c': 'comparative adverb',
  'd-------s': 'superlative adverb',
  'i--------': 'interjection',
  'i----p---': 'interjection, plural',
  'i----s---': 'interjection, singular',
  'ni-------': 'indeclinable noun',
  'p--------': 'preposition',
  'pa-------': 'preposition: with the accusative case',
  'pb-------': 'preposition: with the ablative case',
  'pc-------': 'preposition: with the accusative or ablative case',
};

Expand.xnuk = [
  { a: 10, c: 32, d: 32, i: 32, n: 2, p: 32, r: 32, v: 1 }, // 0: part of speech
  { d: 32, i: 32, g: 32, j: 32, n: 5, p: 32, s: 32 }, // 1: mood
  { f: 14, i: 7, p: 7, x: 7, y: 32, z: 16 }, // 2: tense
  { a: 32, d: 32, i: 12, p: 30 }, // 3: voice
  { a: 1, b: 1, c: 1 }, // 4: person
  { p: 3, s: 3 }, // 5: number
  { a: 2, b: 6, d: 9, g: 11, l: 32, n: 2, v: 12 }, // 6: case
  { c: 2, f: 2, m: 2, n: 2 }, // 7: gender
  { c: 14, s: 8, x: 10 }, // 8: degree
  { q: 11, n: 11, v: 32 }, // 9: suffix
];

Expand.xnpuk = [
  { a: 15, c: 35, d: 22, i: 35, n: 3, p: 29, r: 19, v: 5 },
  { d: 20, i: 25, g: 27, j: 27, n: 14, p: 21, s: 25 },
  { f: 33, i: 7, p: 7, x: 7, y: 34, z: 17 }, // *** tense: f=33
  { a: 23, d: 33, i: 13, p: 22 }, // *** voice: a=23, p=22
  { a: 5, b: 5, c: 5 },
  { p: 5, s: 6 },
  { a: 3, b: 29, d: 10, g: 18, l: 35, n: 3, v: 20 },
  { c: 19, f: 19, m: 19, n: 19 },
  { c: 11, s: 9, x: 12 },
  { q: 14, n: 12, v: 42 },
];

Expand.xc = [
  { a: 'adjective:', n: 'noun:', r: 'pronoun:', v: 'verb:' },
  {
    d: 'imperative',
    i: 'indicative',
    g: 'gerund',
    j: 'gerundive',
    n: 'infinitive',
    p: 'participle',
    s: 'subjunctive',
  },
  { f: 'future', i: 'imperfect', p: 'present', x: 'perfect', y: 'future perfect', z: 'pluperfect' },
  { a: 'active', d: 'active (deponent)', i: 'active (irregular)', p: 'passive' },
  { a: '1st person', b: '2nd person', c: '3rd person' },
  { p: 'plural', s: 'singular', p2: 'plur.', s2: 'sing.' },
  {
    a: 'accusative',
    b: 'ablative',
    d: 'dative',
    g: 'genitive',
    l: 'locative',
    n: 'nominative',
    v: 'vocative',
  },
  {
    c: 'masc./fem.',
    f: 'feminine',
    m: 'masculine',
    n: 'neuter',
    f2: 'fem.',
    m2: 'masc.',
    n2: 'neut.',
  },
  { c: 'comparative', s: 'superlative', x: '+ -cum = with' },
  { q: '(+ -que = and)', n: '(+ -ne asking a question)' },
];

Expand.expand = (tx, chparm) => {
  var ch, xa, xc, xn, _xnp;
  var a,
    c,
    i,
    j,
    k,
    n,
    o,
    pos,
    moo,
    _ten,
    _voi,
    _per,
    _num,
    _cas,
    _gen,
    _deg,
    _suf,
    tx1,
    tx2,
    t = '',
    done;
  ch = +chparm;
  xa = Expand.xa;
  xc = Expand.xc;
  xn = Expand.xnuk;
  _xnp = Expand.xnpuk;
  pos = tx.charAt(0);

  n = xn[0][pos];
  if (ch >= n) {
    // only continue if display of this pos allowed at this Stage
    tx1 = tx.substr(0, 9);
    if (xa[tx1] !== undefined) {
      // indeclinable pattern?
      tx2 = tx.substr(9, 1);
      t = xa[tx1];
      if (tx2 !== '-') {
        t += ` ${xc[9][tx2]}`; // add any 'q', 'n', 'v' suffix
      }
    } else {
      a = tx.split('');
      pos = a[0];
      moo = a[1];
      _ten = a[2];
      _voi = a[3];
      _per = a[4];
      _num = a[5];
      _cas = a[6];
      _gen = a[7];
      _deg = a[8];
      _suf = a[9];

      done = false;
      if (!done) {
        k = 'anrv'.indexOf(pos);
        if (k !== -1) {
          if (pos === 'v' && moo === 'p') {
            // verb: participle => go to next line in Expand.order
            k++;
          }
          o = Expand.order[k];
          j = 0;
          t = xc[0][pos];
          for (i = 1; i < 10; i++) {
            j = o[i];
            c = a[j];
            if (c !== '-' && xn[j][c] <= ch) {
              t += ` ${xc[j][c]}`;
            }
          }
        }
      }
    }
  }
  return t;
};
